import React from 'react';
import classNames from 'classnames';
import { InputLabel, InputLabelProps, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardInputWrapperProps } from '@components/StatefulInputs/Base/StandardInputWrapper/StandardInputWrapper.types';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		...theme.typography.h3,
		'backgroundColor': theme.palette.common.white,
		'color': theme.palette.grey[700],
		'display': 'inline-flex',
		'gap': theme.spacing(.5),
		'& > .MuiTypography-root': {
			...theme.typography.h3,
			color: theme.palette.grey[700],
		},
	},
	extraLabel: {
		'&.MuiTypography-root': {
			color: theme.palette.grey[600],
		}
	},
}));

export const StatefulInputLabel: React.FC<
	Pick<StandardInputWrapperProps<unknown>, 'label' | 'extraLabel'> & InputLabelProps
> = ({
	label,
	extraLabel,
	...inputLabelProps
}) => {
	const classes = useStyles();
	const rootClass = classNames(classes.root, inputLabelProps.className);

	if (!label) {
		return null;
	}
	if (!extraLabel) {
		return <InputLabel {...inputLabelProps} className={rootClass}>{label}</InputLabel>;
	}
	return (
		<InputLabel {...inputLabelProps} className={rootClass}>
			<Typography>{label}</Typography>
			<Typography className={classes.extraLabel}>{extraLabel}</Typography>
		</InputLabel>
	);
};
